var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageMeetingRoomsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 90,
    viewBox: "0 0 90 90",
    width: 90,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    fill: "#ff8200",
    r: 45
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(26 26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.773 4h-15a4.773 4.773 0 0 0 -4.773 4.773v9.545a4.746 4.746 0 0 0 2.728 4.3 4.473 4.473 0 0 0 2.045.477h.682v-2.731h-.682a2.045 2.045 0 0 1 -2.045-2.045v-9.546a2.045 2.045 0 0 1 2.045-2.046h15a2.045 2.045 0 0 1 2.045 2.045v9.545a2.045 2.045 0 0 1 -2.045 2.045h-10.787l-.8.8-1.923 1.923h13.51a4.773 4.773 0 0 0 4.773-4.773v-9.539a4.773 4.773 0 0 0 -4.773-4.773z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 14.5v10.227h1.923l.8-.8v-7.382h-.678a2.045 2.045 0 0 1 -2.045-2.045z",
    transform: "translate(.727 3.818)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.1 16h-3.841l-.8.8-1.927 1.927-.8.8-2.732 2.732v1.923h1.923z",
    transform: "translate(.727 4.364)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.773 8h-3.409v2.727h3.409a2.045 2.045 0 0 1 2.045 2.045v9.545a2.045 2.045 0 0 1 -2.045 2.045h-.682v2.727h.682a4.473 4.473 0 0 0 2.045-.477 4.745 4.745 0 0 0 2.727-4.3v-9.539a4.773 4.773 0 0 0 -4.772-4.773zm-15 16.364a2.059 2.059 0 0 1 -2.045-2.045v-2.6l-1.928 1.917-.8.8a4.786 4.786 0 0 0 4.773 4.65h13.513l-2.727-2.727z",
    transform: "translate(1.455 1.455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.727 18.5a2.045 2.045 0 0 1 -2.045 2.045h-.682v7.377l.8.8h1.923z",
    transform: "translate(6.545 5.273)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.435 20h-3.845l8.182 8.182h1.923v-1.923l-2.727-2.727-.8-.8z",
    transform: "translate(4.578 5.818)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.825,
    rx: 1,
    width: 2.825,
    x: 20.008,
    y: 12.475
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.825,
    rx: 0.942,
    width: 1.883,
    x: 15.3,
    y: 12.475
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2.825,
    rx: 1,
    width: 2.825,
    x: 9.65,
    y: 12.475
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMeetingRoomsIcon);
export default __webpack_public_path__ + "static/media/manage-meeting-rooms-icon.c42e6d71.svg";
export { ForwardRef as ReactComponent };